// i18nOwl-ignore [app-youtube.userDataPolicy]
import type {YoutubeAppStruct} from '@cohort/shared/apps/youtube';
import {YoutubeAppSpec} from '@cohort/shared/apps/youtube';
import {SvgAppIcon} from '@cohort/shared-frontend/common/AppIcons';
import type {App} from '@cohort/wallet/apps';
import type {ContentMedia} from '@cohort/wallet/apps/Media';
import type {TriggerIntegration} from '@cohort/wallet/apps/TriggerIntegration';
import {YoutubeVideoContentMedia} from '@cohort/wallet/apps/youtube/medias/video/Media';
import {YoutubeCommentTriggerIntegration} from '@cohort/wallet/apps/youtube/triggers/comment/TriggerIntegration';
import {YoutubeLikeTriggerIntegration} from '@cohort/wallet/apps/youtube/triggers/like/TriggerIntegration';
import {YoutubeSubscribeTriggerIntegration} from '@cohort/wallet/apps/youtube/triggers/subscribe/TriggerIntegration';

const YoutubeApp: App<YoutubeAppStruct> = {
  spec: YoutubeAppSpec,
  perkIntegrations: [],
  triggerIntegrations: [
    YoutubeCommentTriggerIntegration,
    YoutubeLikeTriggerIntegration,
    YoutubeSubscribeTriggerIntegration,
  ] as Array<TriggerIntegration>,
  medias: [YoutubeVideoContentMedia] as Array<ContentMedia>,
  logo: <SvgAppIcon name="youtube" height={40} width={40} />,
  withUserDataPolicy: true,
};

export default YoutubeApp;
